import React from 'react';
import PropTypes from 'prop-types';
import { getTranslation } from 'common/react/utils/translations';

export const RowBanner = ({ qualifierRow, isWildcard }) => {
    return (
        <div
            className={`stats-table__qualifiers-wrapper ${
                isWildcard ? 'stats-table__qualifiers-wrapper--wildcard' : ''
            }`}
        >
            <div className="stats-table__qualifiers-banner stats-table__qualifiers-banner--top"></div>
            <div className="stats-table__qualifiers-banner stats-table__qualifiers-banner--bottom"></div>
            <span className="stats-table__qualifiers-banner-tab">
                {isWildcard
                    ? getTranslation('label.ladder.wildcard')
                    : `${getTranslation('label.ladder.top')} ${qualifierRow}`}
            </span>
        </div>
    );
};

RowBanner.propTypes = {
    qualifierRow: PropTypes.number,
    isWildcard: PropTypes.bool
};
